export default __webpack_public_path__ + "static/hp-brand-deck-09-a5a862a27c276da5e1f6cb5042bdcc29.png";